// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"8afc0e70f6868a7d8198","883":"3542a04d8607cc647deb"}[chunkId] + ".js";
};